import React from 'react';
import './timeline.css';

/**
 * Props:
 *   open           {boolean}
 *   title          {string}
 *   message        {string}
 *   confirmLabel   {string}  default "Confirm"
 *   cancelLabel    {string}  default "Cancel"
 *   confirmVariant {'danger'|'primary'}  default "danger"
 *   onConfirm      {function}
 *   onCancel       {function}
 */
function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'danger',
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="cd-overlay" onClick={onCancel}>
      <div className="cd-box" onClick={e => e.stopPropagation()}>
        {title && <p className="cd-title">{title}</p>}
        {message && <p className="cd-message">{message}</p>}
        <div className="cd-actions">
          <button className="cd-btn cd-cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            className={`cd-btn cd-confirm ${confirmVariant}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
